import axios from '../../utils/axios'
import store from '../store'
import { getFormattedDate, formatDate } from '../../utils/helpers'

export const SEARCH_REPRINT_PACKAGES_LOADER = 'SEARCH_REPRINT_PACKAGES_LOADER'
export const GET_REPRINT_PACKAGES = 'GET_REPRINT_PACKAGES'
export const GET_REPRINT_PACKAGES_ERROR = 'GET_REPRINT_PACKAGES_ERROR'
export const GET_REPRINT_PACKAGES_SEARCH_LIMIT = 'GET_REPRINT_PACKAGES_SEARCH_LIMIT'
export const POST_REPRINT_PACKAGES_SUCCESS = 'POST_REPRINT_PACKAGES_SUCCESS'
export const POST_REPRINT_PACKAGES_FAILED = 'POST_REPRINT_PACKAGES_FAILED'
export const POST_REPRINT_PACKAGES_ERROR = 'POST_REPRINT_PACKAGES_ERROR'

export const SearchPackages = (query, deliveryMethods, dateRange, scanned) => {
  const types = []
  deliveryMethods.map(type => {
    types.push(type.Id)
  })

  // check if Scanned filter is either 'Yes' or 'No', pass in the values. If 'All', we leave
  // out that filter and the query will return all packages, regardless of scanned state
  let searchData = {}
  if (scanned.includes('All')) {
    searchData = {
      Criteria: query,
      DeliveryType: types,
      StartDate: formatDate(dateRange?.beginDate),
      StopDate: formatDate(dateRange?.endDate)
    }
  } else {
    searchData = {
      Criteria: query,
      DeliveryType: types,
      StartDate: formatDate(dateRange?.beginDate),
      StopDate: formatDate(dateRange?.endDate),
      IsScanned: scanned.includes('Yes')
    }
  }

  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    url: config.baseURL + '/package/reprint',
    headers: {
      'Content-Type': 'application/json'
    },
    data: searchData
  }

  return dispatch => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(response => {
        response.data.PackageSearchResult.map(r => {
          // DataGrid requires a unique id be passed to it
          r.id = r.PackageId
          r.ApplicationDate = getFormattedDate(r.ApplicationDate)
          // needs to be in date format in order to be sorted properly within the table
          r.Printed = new Date(r.Printed)
          r.ScannedDate = getFormattedDate(r.ScannedDate)
        })
        dispatch(GetReprintPackages(response?.data?.PackageSearchResult))
        dispatch(GetReprintPackagesSearchLimit(response?.data?.isMoreResultAvailable))
      })
      .catch(error => {
        console.log(`SearchPackages error is: ${error.message}`)
        dispatch(
          GetReprintPackagesError(
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          )
        )
        dispatch(GetReprintPackagesSearchLimit(false))
      })
      .finally(() => {
        dispatch(SetLoading(false))
        setTimeout(() => {
          dispatch(GetReprintPackagesError(''))
        }, 5000)
      })
  }
}

export const PostReprintPackages = (packageIds, reason) => {
  const config = store.getState().global.config
  const axiosConfig = {
    method: 'post',
    url: config.baseURL + '/package/submitreprint',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      PackageIds: packageIds,
      Reason: reason
    }
  }

  return dispatch => {
    dispatch(SetLoading(true))
    return axios(axiosConfig)
      .then(response => {
        // TODO check response and dispatch
        const results = response?.data?.Results
        const successfulReprint = []
        const failedReprint = []
        Object.keys(results).forEach((value) => {
          if (results[value].includes('Success')) {
            successfulReprint.push(value)
          } else {
            failedReprint.push(value)
          }
        })
        dispatch(PostReprintPackagesSuccess(successfulReprint))
        dispatch(PostReprintPackagesFailed(failedReprint))
      })
      .catch(error => {
        console.log(`PostReprintPackages error is: ${error.message}`)
        dispatch(
          PostReprintPackagesError(
            error?.response?.data?.Message
              ? error?.response?.data?.Message
              : error.message
          )
        )
      })
      .finally(() => {
        dispatch(SetLoading(false))
        setTimeout(() => {
          dispatch(PostReprintPackagesError(''))
          dispatch(PostReprintPackagesSuccess([]))
          dispatch(PostReprintPackagesFailed([]))
        }, 5000)
      })
  }
}

export const SetLoading = loading => {
  return {
    type: SEARCH_REPRINT_PACKAGES_LOADER,
    loading
  }
}

export const GetReprintPackages = packages => {
  return {
    type: GET_REPRINT_PACKAGES,
    packages
  }
}

export const GetReprintPackagesSearchLimit = isMoreResultAvailable => {
  return {
    type: GET_REPRINT_PACKAGES_SEARCH_LIMIT,
    isMoreResultAvailable
  }
}

export const GetReprintPackagesError = error => {
  return {
    type: GET_REPRINT_PACKAGES_ERROR,
    error
  }
}

export const PostReprintPackagesSuccess = packages => {
  return {
    type: POST_REPRINT_PACKAGES_SUCCESS,
    reprintSuccess: packages
  }
}

export const PostReprintPackagesFailed = packages => {
  return {
    type: POST_REPRINT_PACKAGES_FAILED,
    reprintFailed: packages
  }
}

export const PostReprintPackagesError = error => {
  return {
    type: POST_REPRINT_PACKAGES_ERROR,
    error
  }
}
